import "./table-row.component.scoped.sass";
import React, { useState, useEffect } from "react";
import { TableRowProps } from "../../types/table-row-props";
import { TableColumn } from "../../types/table-column";
import { history } from "react-router-guard";
import TableTaskButton from "../table-task-button/table-task-button.component";
import { TableDateComponent } from "../table-date/table-date.component";
import { withStyles, MenuItem, ListItemText, Menu, Tooltip } from "@material-ui/core";
import { icons } from "../../statics/icons";
import { useTranslation } from "react-i18next";
import * as _ from "lodash";
import TableLocationButton from "../table-location-button/table-location-button.component";
import StarIcon from '@material-ui/icons/Star';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import EditBuildingDialog from "src/dialogs/edit-building/edit-building.component";
import { BuildingsService } from "src/services/buildings/buildings.service";

const { actionsIco, homeIco, locationIco } = icons;
const StyledMenu = withStyles({
  paper: {
    border: "1px solid #d3d4d5",
  },
})((props) => (
  // @ts-ignore
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "center",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "center",
    }}
    {...props}
  />
));

const StyledMenuItem = withStyles((theme) => ({
  root: {
    fontSize: "13px",
    "&:focus": {
      backgroundColor: "#095db1",
      "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
        color: theme.palette.common.white,
      },
    },
  },
}))(MenuItem);

const StyledTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#095db1',
    color: '#fff',
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}))(Tooltip);

export const TableRowComponent = (props: TableRowProps) => {
  const [t] = useTranslation();
  const emptyObj: any = {};
  const buildingsService = new BuildingsService();
  const { columns, data, title, clickableRow } = props;
  const [row, setRow]: any = useState(data);
  const [openDialog, setOpenDialog] = React.useState(false);
  const [dialogData, setDialogData] = React.useState(emptyObj);

  useEffect(() => {
    setRow(props.data);
    // eslint-disable-next-line
  }, [props.data]);

  const navigator = (type: string) => {
    const isBuildingsPage = window.location.href.includes("building");
    const { id } = data;
    if (isBuildingsPage) {
      if (type === 'scanning') {
        history.push({
          pathname: `/scanning`,
          search: `?id=${id}`,
          data: data
        });
        return;
      }
      history.push({
        pathname: `/${type}/${id}`,
        data: data
      });
    } else {
      history.push(type);
    }
  };

  const handleDialogClose = (updatedBuilding: any) => {
    if (updatedBuilding) {
      setRow({...row, ...updatedBuilding})
    }
    setOpenDialog(false);
    setDialogData(emptyObj);
  };

  async function edit(row: any) {
    const building = await buildingsService.getOneById(row.id);
    setDialogData(building);
    setOpenDialog(true);
    setAnchorEl(null);
  };

  // TODO: APPLY NEW REFACTOR FOR TABLE NAVIGATION
  const tableNavigator = (event: any) => {
    event.stopPropagation();
    const isBuildingsPage = window.location.href.includes("building");
    if (!anchorEl && isBuildingsPage && !dialogData.id) {
      navigator("statistics");
    } else {
      if (clickableRow) {
        const [page, path] = clickableRow
        const completePath = _.get(data, path);
        navigator(`${page}/${completePath}`);
      }
    }
  };

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event: any) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className={"table-row" + (title === "tasks" ? " cursor-auto" : "")} onClick={tableNavigator}>
      {columns.map((column: TableColumn, index: number) => {
        const { fieldName }: any = column;
        return (
          <div
            className={
              "one-column" +
              (column.type === "tasks" || column.type === "locations" || column.type === "actions"
                ? " flex-grow w-100"
                : "") +
              (column.type === "actions" ? " flex-end actions" : "")
            }
            style={{minWidth: `${column.width || 270}px`}}
            key={index}
          >
            {column.type === "string" ? (
              <div>{row[fieldName]}</div>
            ) : column.type === "weekly-monthly" ? (
              <div className="weekly-monthly">
                <div className="weekly">{row[fieldName].weekly}</div>
                <div className="monthly">| {row[fieldName].monthly}</div>
              </div>
            ) : column.type === "activities-hours" ? (
              <div className="activities-hours-col">
                <div className="time">{row[fieldName].hours}:{row[fieldName].minutes} / {row['activities']}</div>
              </div>
            ) : column.type === "address" ? (
              <div className="address-column">
                <img src={homeIco} alt="home" />
                <StyledTooltip title={row[fieldName]} placement="bottom">
                  <div>{row[fieldName]}</div>
                </StyledTooltip>
              </div>
            ): column.type === "location" ? (
              <div className="address-column">
                <img src={locationIco} alt="location" />
                <StyledTooltip title={row[fieldName]} placement="bottom">
                  <div>{row[fieldName]}</div>
                </StyledTooltip>
              </div>
            ) : column.type === "date" ? (
              <TableDateComponent date={row[fieldName]} />
            ) : column.type === "user" ? (
              <div className="user-col">
                <div className="profile-picture">
                  <img src={row[fieldName].image} alt="user" className="user-image" />
                </div>
                <div className="profile-name">
                  {row[fieldName].firstName} <br /> {row[fieldName].lastName}
                </div>
              </div>
            ) : column.type === "tasks" ? (
              <div className="tasks-col">
                {row[fieldName].map((task: any, index: number) => (
                  <div className="task" key={index}>
                    {task && <TableTaskButton task={task} state="inactive" />}
                  </div>
                ))}
              </div>
            ) : column.type === "locations" ? (
              <div className="location-col">
                {row[fieldName].map((location: any, index: number) => (
                  <div className="location" key={index}>
                    {location && <TableLocationButton location={location} />}
                  </div>
                ))}
              </div>
            ) : column.type === "average rating" ? (
              <div className="rating-col">
                {Array(row[fieldName] || 0).fill(0).map((item: any, index: any) => (
                  <div className="star" key={index}>
                    <StarIcon />
                  </div>
                ))}
                {Array(5 - (row[fieldName] || 0)).fill('11').map((item: any, index: any) => (
                  <div className="empty-star" key={index}>
                    <StarBorderIcon />
                  </div>
                ))}
              </div>
            ) : column.type === "actions" ? (
              <div className="buttons">
                {column.fieldName === "buildings" && (
                  <div>
                    <img
                      width="30px"
                      height="30px"
                      alt="actions"
                      onClick={handleClick}
                      src={actionsIco}
                    />
                    <StyledMenu
                      // @ts-ignore
                      id="customized-menu"
                      anchorEl={anchorEl}
                      keepMounted
                      open={Boolean(anchorEl)}
                      onClose={handleClose}
                    >
                      <StyledMenuItem onClick={navigator.bind(null, "scanning")}>
                        <ListItemText primary={t('tasks')} />
                      </StyledMenuItem>
                      <StyledMenuItem
                        onClick={navigator.bind(null, "statistics")}
                      >
                        <ListItemText primary={t('building details')} />
                      </StyledMenuItem>
                      <StyledMenuItem disabled={openDialog} onClick={edit.bind(null, row)}>
                        <ListItemText primary={t('edit')} />
                      </StyledMenuItem>
                    </StyledMenu>
                  </div>
                )}
              </div>
            ) : (
              <div>{row[fieldName]}</div>
            )}
          </div>
        );
      })}
      <EditBuildingDialog data={dialogData} open={openDialog} onClose={handleDialogClose}/>
    </div>
  );
};
